import React from 'react';
import PropTypes from 'prop-types';
import './AdminActionBar.css';

/**
 * Sticky submit bar for the admin forms.
 *
 * The hint is the point. Both pages gate submission on a list of conditions,
 * and before this the only feedback was a greyed-out button — leaving an
 * operator to hunt a fourteen-field form for whichever one was empty. Naming
 * them costs nothing and answers the question directly.
 *
 * `status` takes the button's place rather than sitting beside it, so the bar
 * never offers a live submit control next to a message about the submit that
 * just failed.
 */
export default function AdminActionBar({ requirements, submitLabel, status, busy }) {
  const outstanding = (requirements || []).filter((item) => !item.done);
  const hint =
    outstanding.length === 0
      ? 'All required fields complete'
      : `${outstanding.length} field${outstanding.length === 1 ? '' : 's'} left — ${outstanding
          .map((item) => item.label)
          .join(', ')}`;

  return (
    <div className="itcActionBar">
      <p className="itcActionBarHint">{hint}</p>

      <div className="itcActionBarSlot">
        {status || (
          <button
            type="submit"
            className="itcActionBarSubmit"
            disabled={outstanding.length > 0 || Boolean(busy)}
          >
            {submitLabel}
          </button>
        )}
      </div>
    </div>
  );
}

AdminActionBar.propTypes = {
  requirements: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      done: PropTypes.bool,
    })
  ),
  submitLabel: PropTypes.string.isRequired,
  status: PropTypes.node,
  busy: PropTypes.bool,
};
